import axios from "../axios-auth";
import orginal_axios from "axios";

export const procurementPlanService = {
  getProcurementPlanList,
  getAllProcurementPlanTypes,
  saveProcurementPlan,
  getProcurementPlanDetail,
  exportProcurementPlanExcel,
  getProcurementPlanExcelTemplate,
  saveProcurementPlanExcel,
  saveProcurementPlanAssetExcel,
};

function getProcurementPlanList(
  searchParams,
  page,
  size,
  sortedBy,
  cancelToken
) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy,
  };

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.type) {
    params["type"] = searchParams.type;
  }
  if (searchParams.planYear) {
    params["planYear"] = searchParams.planYear;
  }
  if (searchParams.description) {
    params["description"] = searchParams.description;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.isAddDetails) {
    params["isAddDetails"] = searchParams.isAddDetails;
  }
  if (searchParams.qtyLimit) {
    params["qtyLimit"] = searchParams.qtyLimit;
  }
  if (searchParams.procurementPlanType) {
    params["procurementPlanType"] = searchParams.procurementPlanType;
  }

  return axios.get("/auth/procurement-plans", { params, cancelToken });
}

function getAllProcurementPlanTypes(procurementPlanType) {
  return axios.get("/auth/all-procurement-plan-types/" + procurementPlanType);
}

function saveProcurementPlan(procurementPlan) {
  if (!procurementPlan.id) {
    // new
    return axios.post("/auth/procurement-plan", procurementPlan);
  } else {
    // edit
    return axios.put("/auth/procurement-plan", procurementPlan);
  }
}
function getProcurementPlanDetail(id) {
  return axios.get("/auth/procurement-plan/" + id);
}

function exportProcurementPlanExcel(searchParams) {
  let params = {
    sort: "issueNo,asc",
  };
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.type) {
    params["type"] = searchParams.type;
  }
  if (searchParams.planYear) {
    params["planYear"] = searchParams.planYear;
  }
  if (searchParams.description) {
    params["description"] = searchParams.description;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.isAddDetails) {
    params["isAddDetails"] = searchParams.isAddDetails;
  }
  if (searchParams.finish != null || searchParams.finish != "") {
    params["finish"] = searchParams.finish;
  }
  if (searchParams.procurementPlanType) {
    params["procurementPlanType"] = searchParams.procurementPlanType;
  }

  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/procurement-plan-excel-export",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  }).then(function (response) {
    return {
      blob: new Blob([response.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      headers: response.headers,
    };
  });
}

function getProcurementPlanExcelTemplate(procurementPlanType) {
  let params = {};
  if (procurementPlanType) {
    params["procurementPlanType"] = procurementPlanType;
  }
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/procurement-plan-excel-template",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  }).then(function (response) {
    return {
      blob: new Blob([response.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      headers: response.headers,
    };
  });
}

function saveProcurementPlanExcel(file) {
  return axios.post("/auth/procurement-plan-excel", file, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

function saveProcurementPlanAssetExcel(file) {
  return axios.post("/auth/procurement-plan-asset-excel", file, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
